import { createReducer } from '@reduxjs/toolkit';

import {
  setCareer,
  addCareer,
  changeCareer,
  deleteCareer,
} from '../../Actions/CareerActions';

const career = createReducer([], {
  [setCareer]: (state, action) => {
    return action.payload;
  },
  [addCareer]: (state, action) => {
    return [action.payload, ...state];
  },
  [changeCareer]: (state, action) => {
    return state.map(career_item =>
      career_item._id === action.payload._id ? action.payload : career_item,
    );
  },
  [deleteCareer]: (state, action) => {
    return state.filter(career_item => career_item._id !== action.payload._id);
  },
});

export default career;
